import { Navigate } from "react-router-dom";
import { useAuth, AUTH_STATE } from "@/contexts/AuthContext";

export default function ProtectedRoute({ children, roles }) {
  const { user, state, platformMode } = useAuth();
  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center text-slate-500" data-testid="loading-screen">
        Carregando...
      </div>
    );
  }
  // Modo multi-tenant: sessão pendente de seleção → força tela de seleção.
  if (platformMode && state === AUTH_STATE.NEEDS_TENANT) {
    return <Navigate to="/selecionar-empresa" replace />;
  }
  if (user === false) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) {
    return <Navigate to="/dashboard" replace />;
  }
  return children;
}
